module.exports = __webpack_public_path__ + "media/900_HC_2023_Phishing_Email_Exercise.4997be65.mp4";